(function () {
  if (!('IntersectionObserver' in window)) return;
  var groups = ['.hp-hero-media', '.hp-tate', '.hp-copy', '.hp-laurel > div', '.hp-chapter', '.hp-feature-img', '.hp-feature > div:last-child > *', '.hp-card', '.hp-prom', '.hp-stmt > *', '.hp-gift-img', '.hp-gift-inner > div:last-child > *', '.hp-teiki > div', '.hp-ichigo-head > *', '.hp-ichigo-body', '.hp-ichigo-cta', '.hp-ichigo-band', '.hp-flav-head > *', '.hp-flavor', '.hp-flav-more', '.hp-rev-head > *', '.hp-rev-overall', '.hp-review'];
  var els = document.querySelectorAll(groups.join(','));
  els.forEach(function (el) {
    el.classList.add('hp-rv');
    var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.transitionDelay = Math.min(idx * 110, 550) + 'ms';
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('hp-in'); io.unobserve(e.target); }
    });
  }, { threshold: .1, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
